import { Pipe, PipeTransform } from "@angular/core";
import { Acl, Business, Departament, Team, User } from "../models/model";
import { parse } from "path";

@Pipe({ standalone: true,
  name: "transformBusinessPipe",
})
export class TransformBusinessPipe implements PipeTransform {
  transform(business_temp: any[]): Business[] {
    const business: Business[] = [];
    business_temp.forEach((data: any) => {
      const busi: Business = {
        id: data.id,
        name: data.name,
        affiliate_type: data.affiliate_type,
        email: data.email,
        access: data.access,
        owner_id: data.owner_id,
        logo: data.logo,
        logo_certification: data.logo_certification,
        description: data.description,
        date_create: data.date_create,
        owner_name: data.owner_name,
        rubro: data.rubro,
        cellphone: data.cellphone,
        countryId: data.country_id,
        totalGroups: parseInt(data.total_groups),
        totalRoutes: parseInt(data.total_routes),
        license: data.plan_type,
        totalLicenses: parseInt(data.total_licenses),
        totalLinks: parseInt(data.total_links),
        availableLicenses: parseInt(data.available_licenses),
        type: data.type,
        state: data?.state,
        plataforms: {
          url_facebook: data.urls?.url_facebook,
          url_twitter: data.urls?.url_twitter,
          url_instagram: data.urls?.url_instagram,
          url_youtube: data.urls?.url_youtube,
          url_app: data.urls?.url_app,
          url_streaming_platform: data.urls?.url_streaming_platform,
          url_blog: data.urls?.url_blog,
          url_linkedin: data.urls?.url_linkedin,
          url_tiktok: data.urls?.url_tiktok,
        },
        acl: data.acl
      };

      business.push(busi);
    });

    return business;
  }
}

@Pipe({
  name: "transformUsersPipe",standalone: false
})
export class TransformUsersPipe implements PipeTransform {
  transform(data: any[]): User[] {
    const users: User[] = [];
    data.forEach((data: any) => {
      const user: User = {
        id: data.id ? data.id : data.users_bussiness_id,
        name: data.info?.user_name,
        email: data.info?.email,
        userId: data.user_id,
        countryId: data.info?.country_id,
        date: data.date ? data.date : data.fecha_inscripcion,
        businessId: data.business_id ? data.business_id : data.bussiness_id,
        image: data.info?.user_image,
        lastOnline: data.info?.last_online,
        licenseActivation: data?.license_activation,
        licenseExpiration: data?.license_expiration,
        licenseStatus:
          Date.now() < Date.parse(data?.license_expiration) ? 1 : 0,
      };

      users.push(user);
    });

    return users;
  }
}

@Pipe({
  name: "transformSearchedUsersPipe",standalone: false
})
export class TransformSearchedUsersPipe implements PipeTransform {
  transform(data: any[]): User[] {
    const users: User[] = [];
    data.forEach((data: any) => {
      const user: User = {
        name: data.fields.name[0],
        email: data.fields.email[0],
        userId: data.id,
        image: data.fields.image[0],
        highlights: data.highlights?.name,
      };

      users.push(user);
    });

    return users;
  }
}

@Pipe({
  name: "transformUserPipe",standalone: false
})
export class TransformUserPipe implements PipeTransform {
  transform(data: any): User {
    const users: User = {
      id: data.id ? data.id : data.users_bussiness_id,
      name: data.info?.user_name,
      email: data.info?.email,
      userId: data.user_id,
      countryId: data.info?.country_id,
      date: data.info?.date,
      businessId: data.business_id ? data.business_id : data.bussiness_id,
      image: data.info?.user_image,
      lastOnline: data.info?.last_online,
      licenseActivation: data?.license_activation,
      licenseExpiration: data?.license_expiration,
      licenseStatus: Date.now() < Date.parse(data?.license_expiration) ? 1 : 0,
    };
    return users;
  }
}

@Pipe({
  name: "userInfoPipe",
  standalone: false
})
export class UserInfoPipe implements PipeTransform {
  transform(incomplete: any[], complete: User[]): User[] {
    return incomplete.map((incompleteUser) => {
      const completeUser = complete.find(
        (user: User) => user.userId === incompleteUser.userId
      );
      return completeUser;
    });
  }
}

@Pipe({
  name: "secondsToTimePipe",standalone: false
})
export class SecondsToTimePipe implements PipeTransform {
  transform(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds - hours * 3600) / 60);

    // 21h 30min

    return hours + "h " + (minutes > 9 ? "" + minutes : "0" + minutes) + "min";
  }
}

@Pipe({
  name: "checkPermissions",standalone: false
})
export class CheckPermissionsPipe implements PipeTransform {
  transform(
    userId: string,
    userAcls: Acl,
    teams: Team[],
    id?: string,
    type?: string
  ): boolean {
    // Obtener la lista de equipos
    // Verificar el ACL de cada equipo en la lista
    for (const team of teams) {
      if (team.users.some((user) => user.userId === userId)) {
        if (team.acl) {
          if (team.acl.type === "FULL") {
            return true;
          } else if (team.acl.type === "LIMITED") {
            if (team.acl.permitted[type]?.includes(id)) {
              return true;
            }
          }
        }
      }
    }

    // Verificar el ACL del usuario
    if (userAcls) {
      if (userAcls.type === "FULL") {
        return true;
      } else if (userAcls.type === "LIMITED") {
        if (userAcls.permitted[type]?.includes(id)) {
          return true;
        }
      }
    }

    return false;
  }
}

@Pipe({
  name: "filteredUsersTablePipe",standalone: false
})
export class FilteredUsersTablePipe implements PipeTransform {
  transform(
    users: User[],
    searchQuery: string,
    selectedItems: User[],
    selectedFilter: number,
    acendent: boolean,
    acls: Acl[],
    Teams: Team[]
  ): User[] {

    // const allowedUserIds = acls.map((acl) => acl.userId);
    // Filtrar los usuarios que están presentes en aclsInfo
    users = users.filter((user) =>
      // allowedUserIds.includes(user.userId) &&
      user.name?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    if (selectedFilter === 0) {
      const selectedStudents = users.filter((user) =>
        selectedItems.includes(user)
      );
      const unselectedStudents = users.filter(
        (user) => !selectedItems.includes(user)
      );

      if (acendent) {
        selectedStudents
          .sort((a, b) => a.name.localeCompare(b.name))
          .concat(
            unselectedStudents.sort((a, b) => a.name.localeCompare(b.name))
          );
        return selectedStudents
          .sort((a, b) => a.name.localeCompare(b.name))
          .concat(
            unselectedStudents.sort((a, b) => a.name.localeCompare(b.name))
          );
      }

      return unselectedStudents
        .sort((a, b) => a.name.localeCompare(b.name))
        .concat(selectedStudents.sort((a, b) => a.name.localeCompare(b.name)));
    }

    if (selectedFilter === 1) {
      return users.sort((a, b) => {
        if (acendent) {
          return a.name.localeCompare(b.name);
        }
        return b.name.localeCompare(a.name);
      });
    }

    // con la lista de equipos calcular cuantos equipos tiene cada usuario
    if (selectedFilter === 2) {
      const userTeamsCount = users.map((user) => {
        let count = 0;
        Teams.forEach((team) => {
          if (team.users.some((teamUser) => teamUser.userId === user.userId)) {
            count++;
          }
        });
        return count;
      });

      return users.sort((a, b) => {
        if (acendent) {
          return (
            userTeamsCount[users.indexOf(a)] - userTeamsCount[users.indexOf(b)]
          );
        }
        return (
          userTeamsCount[users.indexOf(b)] - userTeamsCount[users.indexOf(a)]
        );
      });
    }

    // Mapeo de tipos de ACL a valores numéricos para el nuevo filtro
    const aclTypeOrder = {
      FULL: 3,
      LIMITED: 2,
      VIEW: 1,
    };

    if (selectedFilter === 3) {
      return users.sort((a, b) => {
        const aclTypeA =
          acls.find((acl) => acl.userId === a.userId)?.type || "";
        const aclTypeB =
          acls.find((acl) => acl.userId === b.userId)?.type || "";

        const aclTypeOrderA = aclTypeOrder[aclTypeA] || 0;
        const aclTypeOrderB = aclTypeOrder[aclTypeB] || 0;

        if (acendent) {
          return aclTypeOrderA - aclTypeOrderB;
        }
        return aclTypeOrderB - aclTypeOrderA;
      });
    }

    return users;
  }
}

@Pipe({
  name: "filterUsersWithAclPipe",standalone: false
})
export class FilterUsersWithAclPipe implements PipeTransform {
  transform(users: User[], acls: Acl[]): User[] {
    const allowedUserIds = acls.map((acl) => acl.userId);
    return users.filter((user) => !allowedUserIds.includes(user.userId));
  }
}

@Pipe({
  name: "hoursToTimeFormatPipe",standalone: false
})
export class HoursToTimeFormatPipe implements PipeTransform {
  transform(value: number): string {
    const hours = Math.floor(value);
    const minutes = Math.floor((value - hours) * 60);
    const seconds = Math.floor(((value - hours) * 60 - minutes) * 60);

    const formattedHours = this.padNumber(hours, 2);
    const formattedMinutes = this.padNumber(minutes, 2);
    const formattedSeconds = this.padNumber(seconds, 2);

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }

  private padNumber(number: number, size: number): string {
    let result = number.toString();
    while (result.length < size) {
      result = "0" + result;
    }
    return result;
  }
}

@Pipe({
  name: "userWithLicensePipe",standalone: false
})
export class UserWithLicensePipe implements PipeTransform {
  transform(users: User[]): User[] {
    return users.filter((user) => user.licenseStatus === 1);
  }
}

// getCategoriesLogo

@Pipe({ name: "getCategoryLogoPipe",standalone: false })
export class GetCategoryLogoPipe implements PipeTransform {
  transform(category_id: any, campaings: any[]): string {
    let campaing = campaings.find((c) => {
      return c.Category?.id.toString() == category_id;
    });
    return campaing?.Category?.logo;
  }
}

